(function () {
  'use strict';

  // ── ROOT CHECK ─────────────────────────────────────────────
  var ROOT_SEL = '.msc-media';
  var root = document.querySelector(ROOT_SEL);
  if (!root) return;

  var API_URL = 'https://admin-msc.com/api/public/media-credentials';

  // ── HELPERS ────────────────────────────────────────────────
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // ── MODULE 1: SCROLL REVEAL ────────────────────────────────
  var reveals = root.querySelectorAll('.msc-media__reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('msc-media__reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function (el) { observer.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('msc-media__reveal--visible'); });
  }

  // ── MODULE 2: ADD/REMOVE URL ROWS ─────────────────────────
  var urlContainer = document.getElementById('mc-urls-container');
  var addUrlBtn = document.getElementById('mc-add-url');

  if (addUrlBtn && urlContainer) {
    addUrlBtn.addEventListener('click', function () {
      var row = document.createElement('div');
      row.className = 'msc-media__url-row';

      var input = document.createElement('input');
      input.type = 'url';
      input.name = 'portfolio_url';
      input.className = 'msc-media__input msc-media__input--url';
      input.placeholder = 'https://...';

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'msc-media__remove-url';
      removeBtn.setAttribute('aria-label', 'Remove');
      removeBtn.textContent = '\u00D7';
      removeBtn.addEventListener('click', function () {
        row.remove();
      });

      row.appendChild(input);
      row.appendChild(removeBtn);
      urlContainer.appendChild(row);
    });
  }

  // ── MODULE 3: FORM SUBMISSION ──────────────────────────────
  var form = document.getElementById('msc-media-form');
  var errorsEl = document.getElementById('mc-errors');
  var successEl = document.getElementById('mc-success');
  var submitBtn = document.getElementById('mc-submit');
  var submitText = document.getElementById('mc-submit-text');
  var submitSpinner = document.getElementById('mc-submit-spinner');
  var successEmail = document.getElementById('mc-success-email');

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearErrors();

    // Gather values
    var fullName = (form.querySelector('[name="full_name"]').value || '').trim();
    var email = (form.querySelector('[name="email"]').value || '').trim();
    var phone = (form.querySelector('[name="phone"]').value || '').trim();
    var organization = (form.querySelector('[name="organization"]').value || '').trim();
    var coverageDescription = (form.querySelector('[name="coverage_description"]').value || '').trim();
    var ecName = (form.querySelector('[name="emergency_contact_name"]').value || '').trim();
    var ecPhone = (form.querySelector('[name="emergency_contact_phone"]').value || '').trim();

    // Portfolio URLs
    var urlInputs = form.querySelectorAll('[name="portfolio_url"]');
    var portfolioUrls = [];
    urlInputs.forEach(function (input) {
      var val = (input.value || '').trim();
      if (val) portfolioUrls.push(val);
    });

    // Credential type
    var credTypeEl = form.querySelector('[name="credential_type"]:checked');
    var credentialType = credTypeEl ? credTypeEl.value : '';

    // Events
    var eventEls = form.querySelectorAll('[name="events"]:checked');
    var events = [];
    eventEls.forEach(function (el) { events.push(el.value); });

    // Content agreement
    var agreementEl = form.querySelector('[name="content_agreement"]');
    var agreementAccepted = agreementEl ? agreementEl.checked : false;

    // ── CLIENT-SIDE VALIDATION ──
    var errors = [];
    if (!fullName) errors.push('Full name is required.');
    if (!email) errors.push('Email is required.');
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.push('Please enter a valid email address.');
    if (portfolioUrls.length === 0) errors.push('At least one portfolio URL is required.');
    if (!credentialType) errors.push('Please select a credential type.');
    if (events.length === 0) errors.push('Please select at least one event.');
    if (!agreementAccepted) errors.push('You must accept the content agreement.');

    if (errors.length > 0) {
      showErrors(errors);
      return;
    }

    // ── BUILD PAYLOAD ──
    var payload = {
      full_name: fullName,
      email: email,
      portfolio_urls: portfolioUrls,
      credential_type: credentialType,
      events: events,
      content_agreement_accepted: true
    };
    if (phone) payload.phone = phone;
    if (organization) payload.organization = organization;
    if (coverageDescription) payload.coverage_description = coverageDescription;
    if (ecName) payload.emergency_contact_name = ecName;
    if (ecPhone) payload.emergency_contact_phone = ecPhone;

    // ── SUBMIT ──
    setLoading(true);

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { status: res.status, data: data };
        });
      })
      .then(function (result) {
        setLoading(false);

        if (result.status === 201) {
          // Success — hide form, show confirmation
          form.style.display = 'none';
          if (successEmail) successEmail.textContent = email;
          if (successEl) successEl.style.display = 'block';
          return;
        }

        if (result.status === 429) {
          showErrors([result.data.error || "You've already submitted an application recently. If you need to update your application, email shawn@mscracing.com."]);
          return;
        }

        if (result.status === 400 && result.data.details) {
          showErrors(result.data.details);
          return;
        }

        showErrors([result.data.error || 'Something went wrong. Please try again or email shawn@mscracing.com.']);
      })
      .catch(function () {
        setLoading(false);
        showErrors(['Something went wrong. Please try again or email shawn@mscracing.com.']);
      });
  });

  function setLoading(on) {
    if (submitBtn) submitBtn.disabled = on;
    if (submitText) submitText.style.display = on ? 'none' : '';
    if (submitSpinner) submitSpinner.style.display = on ? '' : 'none';
  }

  function showErrors(list) {
    if (!errorsEl) return;
    // Clear previous content safely
    while (errorsEl.firstChild) errorsEl.removeChild(errorsEl.firstChild);
    var ul = document.createElement('ul');
    list.forEach(function (msg) {
      var li = document.createElement('li');
      li.textContent = msg;
      ul.appendChild(li);
    });
    errorsEl.appendChild(ul);
    errorsEl.style.display = 'block';
    errorsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearErrors() {
    if (!errorsEl) return;
    while (errorsEl.firstChild) errorsEl.removeChild(errorsEl.firstChild);
    errorsEl.style.display = 'none';
  }
})();
